import React from 'react';
import PropTypes from 'prop-types';
import {Link, Redirect} from "react-router-dom";

export default class CustomerRow extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            rowClicked: false
        };
    }

    static getLinkTo(customer, query, actualSearchKey) {
        return {
            'pathname': '/members/' + customer.slug,
            'search': '?name=' + (customer.firstName + ' ' + customer.surname).trim() + '&q=' + query + '&actualSearchKey=' + actualSearchKey,
            'state': {member: customer}
        };
    }

    _rowClicked = () => {
        this.setState({
            rowClicked: true
        });
    };

    render() {
        const customer = this.props.customer;
        const linkTo = CustomerRow.getLinkTo(customer, this.props.query, this.props.actualSearchKey);
        if (this.state.rowClicked) {
            return (<Redirect to={linkTo} />);
        }
        return (
            <tr onClick={this._rowClicked}>
                <td><strong>{customer.firstName}</strong></td>
                <td><strong>{customer.surname}</strong></td>
                <td>{customer.email}</td>
                <td>{`${customer.suburb}${customer.suburb ? ', ' : ''}${customer.state}`}</td>
                <td>{customer.postcode}</td>
                <td>{customer.rewardsCardNumber}</td>
                <td><Link to={linkTo} className="btn btn--color btn--xsmall btn--open f-right">View<img className="icon" src="/img/icon-arrowOpen--white.svg" width="10" height="10" /></Link></td>
            </tr>
        )
    }
}

CustomerRow.propTypes = {
    customer: PropTypes.object.isRequired,
    query: PropTypes.string,
    actualSearchKey: PropTypes.string,
};
